import React from 'react';
import { motion } from 'framer-motion';
export function OpeningLead() {
  return <section className="py-20 bg-brand-bg-dark border-b border-brand-gold/10" data-id="element-194">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-195">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="prose prose-lg prose-invert mx-auto text-center" data-id="element-196">
          <p className="text-2xl sm:text-3xl text-gray-300 font-medium leading-relaxed mb-8" data-id="element-197">
            Hay algo que ningún propietario te dice abiertamente...
          </p>

          <p className="text-xl sm:text-2xl text-gray-400 mb-8" data-id="element-198">
            Pero todos lo piensan cuando ven esa pared dañada, ese techo que
            gotea, ese fence que se está cayendo:
          </p>

          <blockquote className="text-3xl sm:text-4xl font-heading font-bold text-brand-gold italic my-12 border-l-4 border-brand-gold pl-6 text-left" data-id="element-199">
            "¿Cuándo lo voy a poder arreglar? ¿Y a quién puedo confiarle mi
            casa?"
          </blockquote>

          <p className="text-xl sm:text-2xl text-gray-300 mb-8 text-left" data-id="element-200">
            No es solo dinero. Es tu inversión más grande. Es el lugar donde
            llegan tus hijos. Es la primera cosa que la gente ve cuando pasan
            por tu calle.
          </p>

          <p className="text-xl sm:text-2xl text-gray-300 mb-12 text-left" data-id="element-201">
            Y lo peor no es el daño en sí mismo — lo peor es haberle dado dinero
            a alguien que prometió arreglarlo... y nunca terminó el trabajo.
          </p>

          <div className="inline-block bg-brand-red/10 border border-brand-red/30 px-8 py-4 rounded-md" data-id="element-202">
            <p className="text-3xl sm:text-4xl font-heading font-bold text-brand-red m-0 uppercase tracking-widest" data-id="element-203">
              Eso se acaba hoy.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}